import React from 'react';
import Button from './button';
import style from './contentCreatorSection.module.css';
import Img from 'gatsby-image';

const ContentCreatorSection = ({ section, imagesSeries }) => {
  const { title, body1 } = section;
  return (
    <div className={style.contentCreatorSectionWrapper}>
      <div className={style.imageContainerWrapperFirst}>
        {imagesSeries?.slice(0, 5).map((e, i) => (
          <span className={style.imageContainer} key={i}>
            <Img
              fluid={e.coverImage.fluid}
              alt={'App promo'}
              css={{ borderRadius: '6px' }}
            />
            {/* <img src="images/operation_dirty_deeds_i.png" alt="test-images" /> */}
          </span>
        ))}
      </div>

      <div className={style.imageContainerWrapperSecond}>
        {imagesSeries?.slice(5, 11).map((e, i) => (
          <span className={style.imageContainer} key={i}>
            <Img
              fluid={e.coverImage.fluid}
              alt={'App promo'}
              css={{ borderRadius: '6px' }}
            />
            {/* <img src="images/operation_dirty_deeds_i.png" alt="test-images" /> */}
          </span>
        ))}
      </div>

      <div className={style.wrapperContainer}>
        <div className={style.contentCreator}>
          <h3>{title}</h3>
          <p>{body1}</p>
          <Button
            title="Apply here!"
            type={'tertiary'}
            link="/become-content-creator"
          />
        </div>
      </div>
    </div>
  );
};

export default ContentCreatorSection;
